import { IApplicationState } from '../types/redux';

export const firstBuilderSelector = (state: IApplicationState) => {
  return state.newbuilding.builders[0];
};
